import type { ILoader } from '../../appstate';
import type { ISupplier } from '../../domain';
import { CreateLoaderReducer } from '../../reducers/GeneralReducers';
import * as SelectSupplierActions from './SelectSupplierActions';

export interface ISupplierSelectionState {
	suppliers: ILoader<ISupplier[]>;
	defaultSupplierId: number;
	selectedSupplierId: number | null;
}

const initialState: ISupplierSelectionState = {
	suppliers: {
		payload: [],
		inProcess: false,
		error: false,
	},
	defaultSupplierId: -1,
	selectedSupplierId: null,
};

const suppliersReducer = CreateLoaderReducer({
	startAction: SelectSupplierActions.LOOKUP_SUPPLIERS_BY_CUSTOMER_ID,
});

export function selectSupplierReducer(state = initialState, action): any {
	switch (action.type) {
		case SelectSupplierActions.LOOKUP_SUPPLIERS_BY_CUSTOMER_ID:
		case SelectSupplierActions.LOOKUP_SUPPLIERS_BY_CUSTOMER_ID_ERROR:
		case SelectSupplierActions.LOOKUP_SUPPLIERS_BY_CUSTOMER_ID_SUCCESS:
			return {
				...state,
				suppliers: suppliersReducer(state.suppliers, action),
				selectedSupplierId:
					action.payload && action.payload.length === 1
						? action.payload[0].id
						: state.selectedSupplierId,
			};
		case SelectSupplierActions.SET_SELECTED_SUPPLIER:
			if (action.supplierId) {
				return {
					...state,
					selectedSupplierId: action.supplierId,
				};
			}
			break;
		case SelectSupplierActions.RESET_SELECTED_SUPPLIER:
			return {
				...state,
				selectedSupplierId: null,
			};
	}
	return state;
}
